import { render } from "./ArmingAuthorityRecords.vue?vue&type=template&id=5b75bfba&scoped=true"
import script from "./ArmingAuthorityRecords.vue?vue&type=script&lang=js"
export * from "./ArmingAuthorityRecords.vue?vue&type=script&lang=js"

import "./ArmingAuthorityRecords.vue?vue&type=style&index=0&id=5b75bfba&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b75bfba"]])

export default __exports__